module.exports = __webpack_public_path__ + "lato-black-33d5f0d956f3fc30bc51f81047a2c47d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-black/lato-black.woff2
// module id = 1066
// module chunks = 0